<template>
  <div>
    <v-card>
      <v-card-title>
        Edit Content
        <v-spacer></v-spacer>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="channelbtn"
            class="mr-2 white--text"
            depressed
            @click.prevent="updateContent()"
            >Save</v-btn
          >
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            depressed
            @click.prevent="cancel()"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card-title>
    </v-card>
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="6">
        <!-- id -->
        <v-card>
          <v-card-text class="mt-2">
            <v-row>
              <v-col cols="12" sm="12" lg="12">
                <div
                  class="
                    subtitle-2
                    blue-grey--text
                    text--darken-2
                    font-weight-regular
                  "
                >
                  ID : {{ this.id }}
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- 비디오 카드영역 -->
        <v-card>
          <v-card-text class="mt-2">
            <v-row>
              <v-col cols="12" sm="12" lg="12">
                <h6
                  class="
                    subtitle-1
                    blue-grey--text
                    text--darken-2
                    font-weight-regular
                  "
                >
                  Video
                </h6>
                <v-row>
                  <v-col cols="12">
                    <div
                      v-if="isContentVideoLoading"
                      class="d-flex justify-center align-center"
                      style="height: 300px"
                    >
                      <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                      ></v-progress-circular>
                    </div>
                    <contentVideo
                      v-if="!isContentVideoLoading"
                      :content="content"
                      :key="contentVideoKey"
                    ></contentVideo>

                    <div class="d-flex align-center mt-3">
                      <div class="">Auto Play</div>
                      <v-switch
                        class="ml-auto mt-0 pt-0"
                        hide-details
                        v-model="autoplay"
                        inset
                      ></v-switch>
                    </div>
                    <div class="text-caption grey--text text--lighten-1 mt-1">
                      <v-icon x-small class="grey--text text--lighten-1"
                        >mdi-alert-circle-outline</v-icon
                      >
                      Autoplay is applied according to the browser's policy.
                    </div>
                    <div class="d-flex align-center mt-3">
                      <div class="">Mute</div>
                      <v-switch
                        class="ml-auto mt-0 pt-0"
                        hide-details
                        v-model="mute"
                        inset
                      ></v-switch>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- 기본정보 입력 카드영역 -->
      <v-col cols="12" sm="12" md="6" lg="6">
        <v-card>
          <v-card-text class="mt-2 pb-7">
            <v-form ref="form1">
              <v-row>
                <v-col cols="12" sm="12" lg="12">
                  <h6
                    class="
                      subtitle-1
                      blue-grey--text
                      text--darken-2
                      font-weight-regular
                    "
                  >
                    Basic
                  </h6>
                  <h6 class="caption font-weight-light">Required input</h6>
                  <v-row>
                    <v-col cols="12" class="mt-3">
                      <v-text-field
                        label="Title"
                        color="channel"
                        required
                        prepend-icon="mdi-format-title"
                        v-model="title"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="Author"
                        color="channel"
                        required
                        prepend-icon="mdi-account"
                        v-model="author"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="mt-3">
                      <v-text-field
                        label="DATE"
                        type="date"
                        prepend-icon="mdi-clock"
                        v-model="date"
                        hide-details
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
        <!-- 옵션 카드영역 -->
        <v-card>
          <v-card-text class="mt-2 pb-7">
            <v-row>
              <v-col cols="12" sm="12" lg="12">
                <v-card-actions>
                  <h6
                    class="
                      subtitle-1
                      blue-grey--text
                      text--darken-2
                      font-weight-regular
                    "
                  >
                    Optional
                  </h6>
                </v-card-actions>
                <v-row>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12">
                        <v-file-input
                          v-show="!slide"
                          v-model="slideFile"
                          label="Slide File upload"
                          accept="application/pdf"
                          prepend-icon="mdi-paperclip"
                          color="channel"
                          :rules="[slideUploadRule]"
                          @change="saveFile()"
                        ></v-file-input>
                        <v-chip
                          v-show="slide"
                          close
                          @click:close="removeFile()"
                          color="channel"
                          text-color="white"
                          class="caption file-chip"
                        >
                          <span>{{ slide }}</span>
                        </v-chip>
                      </v-col>
                      <v-col cols="12">
                        <v-combobox
                          v-model="selectedCategory"
                          :items="channel_categories"
                          item-text="text"
                          item-value="id"
                          label="Select a category"
                          multiple
                          prepend-icon="mdi-expand-all"
                          color="channel"
                          return-object
                        >
                          <template slot="selection" slot-scope="data">
                            {{ data.item.category_name }}
                            <div class="cate-info-text pr-2">
                              {{ data.item.category_info }}
                            </div>
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ data.item.category_name }}
                            <div class="cate-info-text">
                              {{ data.item.category_info }}
                            </div>
                          </template>
                        </v-combobox>
                        <div class="d-flex justify-end pa-0">
                          <v-btn
                            class="ml-auto mt-0"
                            depressed
                            color="teal"
                            small
                            dark
                            @click="editCategory"
                            >Edit Category</v-btn
                          >
                        </div>
                      </v-col>

                      <v-col cols="12" class="mt-4">
                        <v-textarea
                          outlined
                          v-model="info"
                          placeholder="Content information."
                          hide-details
                        ></v-textarea>
                      </v-col>
                      <!-- 카테고리 편집 -->
                      <v-dialog
                        v-model="contentCategoryDialog"
                        max-width="800px"
                      >
                        <contentCategory
                          :content_id="id"
                          v-on:onCloseContentCategoryDialog="
                            closeContentCategoryDialog
                          "
                          v-on:onUpdateCategoryList="updateCategoryList"
                        ></contentCategory>
                      </v-dialog>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- 프라이버시 카드영역 -->
        <v-card>
          <v-card-text class="mt-2 pb-7">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <h6
                  class="
                    subtitle-1
                    blue-grey--text
                    text--darken-2
                    font-weight-regular
                  "
                >
                  Privacy
                </h6>
                <h6 class="caption font-weight-light">
                  Choose who can (or can’t) see your video.
                </h6>
                <v-row>
                  <v-col cols="12" class="mt-3">
                    <v-select
                      v-model="who"
                      :items="whoOptions"
                      label="Who"
                      color="primary"
                      item-text="label"
                      prepend-icon="mdi-security"
                      hide-details
                    ></v-select>
                  </v-col>
                  <!-- KEY 방식 -->
                  <v-col cols="12" v-show="who == 'key'">
                    <v-form ref="form2">
                      <v-text-field
                        v-model="key"
                        label="KEY"
                        color="primary"
                        :rules="[ruleKey]"
                        counter="10"
                        class="pa-0 ma-0 ml-10"
                        outlined
                        dense
                      ></v-text-field>
                    </v-form>
                  </v-col>
                  <!-- Allowd User 방식 -->
                  <v-col cols="12" v-if="who == 'allowed'" class="d-flex">
                    <v-btn
                      class="ml-auto"
                      depressed
                      color="teal"
                      small
                      dark
                      @click="editUsers"
                      >Edit Allowed Users</v-btn
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="when"
                      :items="whenOptions"
                      color="primary"
                      label="When"
                      item-text="label"
                      prepend-icon="mdi-timer"
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="12" v-if="when == 'schedule'">
                    <div class="d-flex ml-9">
                      <v-icon class="text-center pr-2"
                        >mdi-calendar-clock</v-icon
                      >
                      <VueCtkDateTimePicker
                        id="WhenStartTimePicker"
                        label="Start"
                        v-model="when_start"
                        format="YYYY-MM-DD HH:mm"
                        formatted="YYYY-MM-DD HH:mm"
                        minuteInterval="5"
                        class="pr-2"
                        right
                        color="purple"
                      />
                      <VueCtkDateTimePicker
                        id="WhenEndTimePicker"
                        label="End"
                        v-model="when_end"
                        format="YYYY-MM-DD HH:mm"
                        formatted="YYYY-MM-DD HH:mm"
                        right
                        minuteInterval="5"
                        color="purple"
                      />
                    </div>
                    <div class="d-flex ml-9">
                      <h6 class="ml-auto caption font-weight-light pa-1">
                        timezone: {{ timezone }}
                      </h6>
                    </div>
                    <div class="d-flex ml-9">
                      <h6
                        class="ml-auto caption font-weight-light pa-1 red--text"
                      >
                        {{ this.ruleTextSchedule }}
                      </h6>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="where"
                      :items="whereOptions"
                      label="Where"
                      color="primary"
                      item-text="label"
                      prepend-icon="mdi-server-network"
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="12" v-if="where == 'domain'">
                    <v-form ref="form3">
                      <v-text-field
                        v-model="domain"
                        label="ex) www.naver.com"
                        color="channel"
                        clearable
                        append-icon="mdi-plus"
                        @click:append="addDomain"
                        class="ml-9"
                      ></v-text-field>
                    </v-form>
                    <div
                      class="d-flex justify-end pa-0"
                      v-for="(where_domain, i) in where_domains"
                      :key="i"
                    >
                      <v-btn text small class="domain"
                        >{{ where_domain
                        }}<v-icon small @click="removeDomain(where_domain)"
                          >mdi-delete-forever</v-icon
                        ></v-btn
                      >
                    </div>
                  </v-col>
                  <!-- 컨텐츠 허용유저 -->
                  <v-dialog
                    v-model="contentUsersDialog"
                    style="z-index: 10000"
                    max-width="600px"
                  >
                    <contentAllowedUser
                      :content_id="id"
                      :who_groups="who_groups"
                      v-on:onCloseContentUsersDialog="closeContentUsersDialog"
                      v-on:onUpdateGroups="updateWhoGroups"
                    ></contentAllowedUser>
                  </v-dialog>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="4"> </v-col>
    </v-row>
  </div>
</template>
<script>
import moment from "moment-timezone";
import { createFile, updateContent, deleteFile } from "../graphql/Mutation";
import { getContent, listCategories } from "../graphql/Query";
import { Base64 } from "js-base64";
const _up = process.env.VUE_APP_KEY_MASS_UP;
const _down = process.env.VUE_APP_KEY_MASS_DOWN;

const contentVideo = () => import("@/components/ContentVideo");
const contentAllowedUser = () => import("@/components/ContentAllowedUser");
const contentCategory = () => import("@/components/ContentCategory");
export default {
  name: "ContentEdit",
  components: {
    contentVideo,
    contentAllowedUser,
    contentCategory
  },
  data: () => ({
    contentVideoKey: 0,
    content: null,
    contentUsersDialog: false,
    contentCategoryDialog: false,
    channel_categories: [],
    editInfo: "",
    isContentVideoLoading: true,
    // content
    id: "",
    title: "",
    author: "",
    date: "",
    info: "",
    status: "",
    slide: "",
    slideFile: null,
    tags: [],
    categories: [],
    search: "",
    who: "me",
    who_groups: [],
    key: "",
    groups: "",
    when: "permanent",
    when_start: "",
    when_end: "",
    where: "anywhere",
    domain: "",
    autoplay: false,
    mute: false,
    stream_url: "",
    stream_mode: "",

    where_domains: [],
    whoOptions: [
      /** me, anyone, key, allowd */
      { label: "Only me", value: "me" },
      { label: "Anyone", value: "anyone" },
      { label: "Users with key", value: "key" },
      { label: "Allowed users", value: "allowed" }
    ],
    whereOptions: [
      { label: "Anywhere", value: "anywhere" },
      { label: "Specific domains", value: "domain" }
    ],
    whenOptions: [
      { label: "Permanent", value: "permanent" },
      { label: "Schedule", value: "schedule" }
    ],
    addItems: [
      { title: "Upload Videos", action: "upload" },
      { title: "Embed Video", action: "embed" }
    ],
    selectedCategory: [],

    width: "",
    ruleTextSchedule: ""
  }),
  computed: {
    timezone: function() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    minDate: function() {
      const currentTime = moment()
        .tz(this.timezone)
        .format();
      return currentTime;
    },
    date_local: function() {
      return this.date
        ? moment(this.date)
            .tz(this.timezone)
            .format()
        : null;
    },
    when_start_local: function() {
      return this.when_start
        ? moment(this.when_start)
            .tz(this.timezone)
            .format()
        : null;
    },
    when_end_local: function() {
      return this.when_end
        ? moment(this.when_end)
            .tz(this.timezone)
            .format()
        : null;
    },
    selectedCategoryIds: function() {
      return this.selectedCategory.map(cate => cate.id);
    }
  },
  async mounted() {
    this.id = this.$route.query.content_id;
    await this.init();
  },
  watch: {},
  methods: {
    addDomain() {
      if (this.domain) {
        this.where_domains.push(this.domain);
      }
      this.domain = "";
    },
    async cancel() {
      // await this.init();
      this.$router.push({
        name: "Contents",
        query: { from: "edit" }
      });
    },
    checkSelectedCategory() {
      // 카테고리 select 표시
      console.log("[categories]", this.categories);
      console.log("[channel_categories]", this.channel_categories);
      this.selectedCategory = [];
      if (this.categories.length > 0) {
        this.categories.forEach(item => {
          this.channel_categories.forEach(ch_cate => {
            if (ch_cate.id == item) this.selectedCategory.push(ch_cate);
          });
        });
      }
    },
    closeContentUsersDialog() {
      this.contentUsersDialog = false;
    },
    closeContentCategoryDialog() {
      this.contentCategoryDialog = false;
    },
    editUsers() {
      this.contentUsersDialog = true;
    },
    editCategory() {
      this.contentCategoryDialog = true;
    },

    async getContent(id) {
      /**
       * 컨텐츠 정보 가져오기
       */
      try {
        const { data } = await this.$apollo.query({
          query: getContent,
          variables: {
            id: id
          },
          fetchPolicy: "no-cache"
        });
        console.log("[Content Edit]", data);
        const content = data.getContent;
        this.content = content;
        this.id = content.id;
        this.title = content.title;
        this.date = content.date;
        this.author = content.author;
        this.info = content.info;
        this.status = content.status;
        this.slide = content.slide;
        this.tags = content.tags ? content.tags : [];
        this.categories = content.categories ? content.categories : [];
        this.who = content.who;
        this.who_groups = content.who_groups ? content.who_groups : [];
        this.key = content.key
          ? Base64.decode(content.key)
              .replace(_up, "")
              .replace(_down, "")
          : "";
        this.when = content.when;
        this.when_start = content.when_start;
        this.when_end = content.when_end;
        this.where = content.where;
        this.where_domains = content.where_domains ? content.where_domains : [];
        // this.stream_mode = content.stream_mode;
        // this.stream_url = content.stream_url;
        this.autoplay = content.autoplay ? content.autoplay : false;
        this.mute = content.mute ? content.mute : false;
      } catch (e) {
        console.log("[Content Edit] fail", e);
      }
    },
    async getListCategories() {
      /**
       * 채널에 해당하는 그룹목록 가져오기
       */
      const limit = undefined;
      const nextToken = undefined;
      try {
        const { data } = await this.$apollo.query({
          query: listCategories,
          variables: {
            channel_id: this.$store.state.channelId,
            limit: limit,
            nextToken: nextToken
          },
          fetchPolicy: "no-cache"
        });
        console.log("[CategoryList]", data);

        const categories = data.listCategories.items;

        categories.sort((a, b) => (a.category_name < b.category_name ? 1 : -1));
        categories.forEach(category => {
          category.text =
            category.category_name + " - " + category.category_info;
          category.value = category.id;
        });

        this.channel_categories = categories;
        console.log("=====", this.channel_categories);
      } catch (e) {
        console.log("[CategoryList] listCategory failed");
      }
    },
    async init() {
      this.isContentVideoLoading = true;
      await this.getContent(this.id);
      await this.getListCategories();
      this.checkSelectedCategory();
      this.isContentVideoLoading = false;
    },
    removeTag(item) {
      // console.log("removeTag", item);
      const idx = this.tags.findIndex(tag => tag == item);
      if (idx > -1) this.tags.splice(idx);
    },
    removeDomain(domain) {
      const index = this.where_domains.indexOf(domain);
      if (index > -1) {
        this.where_domains.splice(index, 1);
      }
    },
    async removeFile() {
      const fileName = this.slide;
      if (!fileName) return;
      console.log(fileName, this.$store.state.channelId, this.id);
      try {
        const { data } = await this.$apollo.mutate({
          mutation: deleteFile,
          variables: {
            name: fileName,
            channel_id: this.$store.state.channelId,
            content_id: this.id,
            mode: "file"
          },
          fetchPolicy: "no-cache"
        });

        console.log({ data });
        // DB저장
        if (data.deleteFile) {
          await this.updateSlide(null);
          this.slideFile = null;
        }
      } catch (e) {
        console.log("Update delete file", e);
      }
    },
    ruleKey(v) {
      if (this.who == "key" && !v) return "Required.";
      if (this.who == "key" && v.length > 10)
        return "Key value must be less than 10 characters";
      return true;
    },
    ruleWhenStart(v) {
      console.log(this.when);
      if (this.when == "schedule" && !v) return "Required.";
      console.log(this.when_end);
      if (this.when == "schedule") {
        const s = moment(this.when_start);
        const e = moment(this.when_end);
        console.log(e.diff(s));
        if (e.diff(s) < 0) return "The start date must precede the end date.";
      }
      return true;
    },
    ruleWhenEnd(v) {
      if (this.when == "schedule" && !v) return "Required.";
      if (this.when == "schedule") {
        const s = moment(s);
        const e = moment(e);
        if (e.diff(s) > 0)
          return "The end date must be later than the start date.";
      }
      return true;
    },
    async saveFile() {
      // 업로드
      const file = this.slideFile;
      const validation = this.slideUploadRule(file);
      console.log("Execute saveFile", file, validation);
      if (validation !== true) return;

      try {
        const { data } = await this.$apollo.mutate({
          mutation: createFile,
          variables: {
            name: file.name,
            fileType: file.type,
            channel_id: this.$store.state.channelId,
            content_id: this.id,
            mode: "file"
          },
          fetchPolicy: "no-cache"
        });

        if (data) {
          const returnedUrl = data.createFile.url;
          try {
            await this.$axiosS3Public.put(returnedUrl, file, {
              headers: { "Content-Type": file.type }
            });
            this.uploadSlideSuccess = true;
          } catch (e) {
            this.uploadSlideSuccess = false;
          }
        }
      } catch (e) {
        console.log("Upload Eror", e);
      }

      // DB저장
      if (this.uploadSlideSuccess) {
        try {
          await this.updateSlide(file.name);
        } catch (e) {
          console.log("Update db", e);
        }
      }
    },
    slideUploadRule(value) {
      if (value == null) return true;
      if (value && value.size > 104857600)
        return "Pdf size should be less than 100 MB!";
      console.log("2");
      let name = value.name;
      if (
        value &&
        name.slice(name.length - 3, name.length).toLowerCase() != "pdf"
      )
        return "Just pdf file is allowed.";
      console.log("3");
      return true;
    },
    async updateSlide(slideName) {
      const updateInput = {
        id: this.id,
        channel_id: this.$store.state.channelId,
        slide: slideName
      };

      console.log(updateInput);
      try {
        const { data } = await this.$apollo.mutate({
          mutation: updateContent,
          variables: {
            input: updateInput
          },
          fetchPolicy: "no-cache"
        });

        if (data && data.updateContent) {
          this.slide = slideName;

          if (slideName) {
            this.$store.dispatch("logger", {
              menu: "Contents",
              level: "success",
              message: `Success for uploading ${slideName}`
            });
          } else {
            this.$store.dispatch("logger", {
              menu: "Contents",
              level: "success",
              message: `Success for delete file.`
            });
          }
        }
      } catch (e) {
        this.$store.dispatch("logger", {
          menu: "Contents",
          level: "error",
          message: `Fail to upload ${slideName}`
        });
        console.log("[Contents] Update ", e);
      }
    },
    async updateContent() {
      if (!this.$refs.form1.validate()) return null; //basic
      if (!this.$refs.form2.validate()) return null; //basic

      console.log("키가 룰에 맞나?", this.ruleKey(this.key));
      // console.log(this.ruleWhenStart(this.when_start));
      if (this.ruleWhenStart(this.when_start) !== true) {
        this.ruleTextSchedule = this.ruleWhenStart(this.when_start);
        setTimeout(() => {
          this.ruleTextSchedule = "";
        }, 8000);
        return null;
      }

      if (this.ruleWhenEnd(this.when_end) !== true) {
        this.ruleTextSchedule = this.ruleWhenStart(this.when_end);
        setTimeout(() => {
          this.ruleTextSchedule = "";
        }, 8000);
        return null;
      }
      const updateInput = {
        id: this.id,
        channel_id: this.$store.state.channelId,
        title: this.title,
        date: this.date,
        author: this.author,
        info: this.info,
        tags: this.tags,
        categories: this.selectedCategoryIds,
        autoplay: this.autoplay,
        mute: this.mute,
        // poster: this.poster,
        // stream_mode: this.stream_mode,
        // stream_url: this.stream_url,
        who: this.who,
        who_groups: this.who_groups,
        key: this.key,
        when: this.when,
        where: this.where,
        where_domains: this.where_domains
      };
      updateInput.when_start = this.when_start_local; //2021-03-24 12:00  => 2021-03-24T12:00+09:00  =>12645645645644
      updateInput.when_end = this.when_end_local;

      console.log("updateContent Exec", updateInput);

      try {
        const { data } = await this.$apollo.mutate({
          mutation: updateContent,
          variables: {
            input: updateInput
          },
          fetchPolicy: "no-cache"
        });

        if (data && data.updateContent) {
          const res = data.updateContent;

          console.log({ updateInput, res });
          // updateContent 결과 리스트에 업데이트
          this.content.id = res.id;
          this.content.channel_id = this.$store.state.channelId;
          this.content.title = res.title;
          this.content.author = res.author;
          this.content.info = res.info;
          this.content.date = res.date;
          this.content.tags = res.tags;
          this.content.categories = res.categories;
          // this.content.stream_mode = res.stream_mode;
          // this.content.stream_url = res.stream_url;
          // this.content.poster = res.poster;
          this.content.who = res.who;
          this.content.key = res.key;
          this.content.when = res.when;
          this.content.where = res.where;
          this.content.where_domains = res.where_domains;
          this.content.autoplay = res.autoplay;
          this.content.mute = res.mute;
          // this.contentVideoKey += 1;
          this.$store.dispatch("logger", {
            menu: "Contents",
            level: "success",
            message: `Success for Updating ${this.id} Content.`
          });
        }
      } catch (e) {
        this.$store.dispatch("logger", {
          menu: "Contents",
          level: "error",
          message: `Fail for Updating  ${this.id} Content.`
        });
        console.log("[Contents] Update Content", e);
      }
      // 목록페이지로 이동
      this.$router.push({
        name: "Contents",
        query: { from: "edit" }
      });
    },
    updateWhoGroups(evt) {
      this.who_groups = evt;
    },
    updateCategoryList(evt) {
      this.channel_categories = evt;
      this.checkSelectedCategory();
    }
    // updateVideo(evt) {
    //   console.log("video updated", evt);
    //   if (evt.stream_mode) this.stream_mode = evt.stream_mode;
    //   if (evt.stream_url) this.stream_url = evt.stream_url;
    //   if (evt.poster) this.poster = evt.poster;
    //   if (evt.poster_upload) this.poster_upload = evt.poster_upload;
    // }
  }
};
</script>
<style scoped>
.v-input {
  font-size: 0.9em;
}
.cate-info-text {
  font-size: 12px;
  color: rgb(146, 146, 146);
  padding-left: 5px;
}
</style>
